export const getObservation = state => state.observation;
